import { BundleCombination, BundleCombinationItem, BundleProduct, Product } from "../types/product";

export function bundleHasVariations(bundleProducts?: BundleProduct[]): boolean {
  if (!bundleProducts || bundleProducts.length === 0) return false;

  return bundleProducts.some((bp) => bp.allowedVariationIds && bp.allowedVariationIds.length > 0);
}

export function cartBundleSelectionsToCombination(
  product: Product,
  bundleSelections: Array<{ bundleItemProductId: string; selectedVariationId?: string }>
): BundleCombination {
  const items: BundleCombinationItem[] = bundleSelections.map((sel) => {
    const bundleProduct = product.bundleProducts?.find((bp) => bp.productId === sel.bundleItemProductId);
    const quantity = bundleProduct?.quantity ?? 1;

    if (sel.selectedVariationId) {
      return {
        productId: sel.selectedVariationId,
        parentProductId: sel.bundleItemProductId,
        isVariation: true,
        quantity,
      };
    }

    return {
      productId: sel.bundleItemProductId,
      isVariation: false,
      quantity,
    };
  });

  return {
    id: items.map((i) => i.productId).join("_"),
    items,
  };
}

const bundleCore = {
  bundleHasVariations,
  cartBundleSelectionsToCombination,
};

export default bundleCore;
